import * as React from 'react';
import {
  Grid, Card, CardHeader, CardContent, Typography, Paper,
} from '@material-ui/core';
import type { GridColumns } from '@material-ui/data-grid';
import {
  DataGrid,
} from '@material-ui/data-grid';
import axios from 'axios';
import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import { colors } from '../../theme';
import globalUseStyles from '../../globalClasses';

const useStyles = makeStyles(() => createStyles({
  textBlue: {
    color: colors.primary,
  },
}));
interface IScan {
  scanBody: string;
  scanType: string;
  scanLocation: string;
  created: string;
}

const ScanLookup: React.FC<unknown> = () => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();
  const { enqueueSnackbar } = useSnackbar();
  const fetcher = (url: string) => axios.get<IScan[]>(url)
    .then((response) => response.data)
    .catch(() => {
      enqueueSnackbar('Unable to retrieve scans');
    });

  const { data } = useSWR(['/scans/getScans'], (url) => fetcher(url));

  const tableColumns: GridColumns = [
    {
      field: 'scanBody',
      headerName: 'Body',
      flex: 1,
    },
    {
      field: 'scanType',
      headerName: 'Type',
      flex: 1.25,
    },
    {
      field: 'scanLocation',
      headerName: 'Scan Location',
      flex: 1,
    },
    {
      field: 'created',
      headerName: 'Created',
      flex: 1,
    },
  ];

  const tableRows = data && data?.map((scan, index) => ({
    id: index || '',
    scanBody: scan.scanBody,
    scanType: scan.scanType,
    scanLocation: scan.scanLocation,
    created: scan.created,
  }));

  return (
    <Grid xs={12} md={8}>
      <Paper>
        <Card>
          <CardHeader
            title={(
              <Typography className={classes.textBlue} variant="h6" display="inline">{'Last 100 Scans'}</Typography>
              )}
            disableTypography
          />
          <CardContent>
            <DataGrid
              rows={tableRows || []}
              columns={tableColumns}
              disableColumnMenu
              autoHeight
              pageSize={10}
              className={globalStyles.transparentDataGrid}
            />
          </CardContent>
        </Card>
      </Paper>
    </Grid>
  );
};

export default ScanLookup;
